var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CFooter',{attrs:{"fixed":false}},[_c('div',[_c('a',{attrs:{"href":"https://www.gecco-fahrschulen.de/","target":"_blank"}},[_vm._v("© Gecco Media GmbH | All rights reserved")])])])}
var staticRenderFns = []

export { render, staticRenderFns }